import React, { Component } from "react";
import { Accordion, Table } from "semantic-ui-react";
import _ from "lodash";

class GoogleDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0
    };
  }
  handleClick = () => {
    if (this.state.activeIndex === 0) {
      this.setState({ activeIndex: -1 });
    } else {
      this.setState({ activeIndex: 0 });
    }
  };

  openwindow = url => window.open(url, "_blank");

  render() {
    const rows = [];
    if (this.props.node !== undefined && this.props.node.length > 0) {
      _.forEach(this.props.node, (person, index) => {
        const title = _.get(person, "title[0]._", "");
        rows.push(
          <Table.Row key={`url_row_${index}`}>
            <Table.Cell>
              <a
                target={"_blank"}
                title={title}
                rel={"noopener noreferrer"}
                href={`${_.get(person, "url[0]._", "")}`}
              >
                {title}
              </a>
            </Table.Cell>
          </Table.Row>
        );
      });
    } else {
      rows.push(
        <Table.Row>
          <Table.Cell>No Records Found</Table.Cell>
        </Table.Row>
      );
    }

    return (
      <Accordion fluid styled>
        <Accordion.Title
          active={this.state.activeIndex === 0}
          key={`GoogleTitle`}
          onClick={() => this.handleClick()}
        >
          <p>Google</p>
        </Accordion.Title>
        <Accordion.Content
          key={`GoogleBody`}
          active={this.state.activeIndex === 0}
        >
          <Table>
            <Table.Body>{rows}</Table.Body>
          </Table>
        </Accordion.Content>
      </Accordion>
    );
  }
}
export default GoogleDetail;



// WEBPACK FOOTER //
// ./src/components/searchresults/GoogleDetail.js